export function getLogoFontSizeStyles(name: string) {
  const baseStyles = 'font-semibold break-words';

  if (name.length > 30) {
    return `${baseStyles} lg:text-[20px] text-sm lg:leading-[18px] -tracking-[0.20px]`;
  }

  return `${baseStyles} lg:text-[24px] text-lg lg:leading-6 -tracking-[0.24px]`;
}
